import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import './index.css';

export const ConfirmationPopUp = ({ show=false, title="", bodyMsg=[], isLoading=false, onYes=null, onNo=null }) => (
    <Modal centered className="configConfirmationModal" show={show} onHide={isLoading ? null : onNo} backdrop="static">
      <Modal.Header closeButton style={{ border: 0 }}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      
      {bodyMsg.map(msg => <Modal.Body>{msg}</Modal.Body>)}

      <Modal.Footer style={{ border: 0, justifyContent: 'flex-start' }}>
        <Button  style={styles.yesBtn} disabled={isLoading}  onClick={isLoading ? null : onYes}>
          {isLoading ? <Spinner style={{ margin: 0 }} animation="border" size="sm" variant="light" /> : 'Yes'}
        </Button>
        <Button style={styles.noBtn} disabled={isLoading} onClick={isLoading? null : onNo}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
);

const styles = {
  yesBtn: {
    width:100,
    height: 38,
    backgroundColor: '#0d8177',
    color: 'white',
    borderWidth: 1,
    borderColor: '#0d8177',
    borderStyle: 'solid',
    justifyContent: 'center'
  },
  noBtn: {
    width: 100,
    backgroundColor:'white',
    borderWidth: 1,
    borderColor: '#402ca8',
    borderStyle: 'solid',
    color:'#402ca8'
  }
};